import React, { useState } from "react";
import { ReactComponent as CloseIcon } from "static/images/close.svg";
import useRoveFocus from "hooks/useRoveFocus";
import ListItem from "components/ListItem";

const GatwickModal = ({ closeModal, type, options, handleChange }) => {
  const [showList, setShowList] = useState(false);
  const [focus, setFocus] = useRoveFocus(options.length);

  const hideList = () => setShowList(false);

  const handleShowList = () => setShowList(true);
  return (
    <div className="otrl-jp__modal-input">
      <div className="otrl-jp__modal-input__header">
        <div className="otrl-jp__modal-input__header__bar">
          <h1 className="otrl-jp__modal-input__title">{"Leaving from ..."}</h1>
          <button
            className="otrl-jp__modal-input__close"
            type="button"
            onClick={closeModal}
            aria-label="Close"
          >
            <CloseIcon />
          </button>
        </div>
      </div>
      <div className="otrl-jp__gatwick-express-modal">
        <input
          className="otrl-jp__gatwick-express-modal-input"
          autocomplete="off"
          data-lpignore="true"
          placeholder="Leaving from..."
          onClick={handleShowList}
          onKeyUp={handleShowList}
          onChange={handleShowList}
          name={"gatwick_input_modal"}
          value={type?.label || ""}
        />
      </div>
      {showList ? (
        <div>
          <h3 className="otrl-jp__stations-list__heading">Journeys</h3>
          <ul
            className="otrl-jp__stations-list__list"
            role="navigation"
            aria-label="Recent stations list"
          >
            {options.map((station, index) => {
              if (station.disabled) {
                return;
              }

              return (
                <ListItem
                  key={index}
                  className="otrl-jp__stations-list__list__item"
                  setFocus={setFocus}
                  focus={focus === 0}
                  index={index}
                  onSelect={() => {
                    handleChange(station.value);
                    hideList();
                  }}
                  onTab={hideList}
                >
                  {station.label}
                </ListItem>
              );
            })}
          </ul>
        </div>
      ) : (
        ""
      )}
    </div>
  );
};

export default GatwickModal;
